import { connect } from 'react-redux';
import { actions } from '../redux';
import { getCollection } from '../redux/selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
const mapStateToProps = (state, ownProps)=>{
    return {
        exampleCollection: ownProps.exampleCollectionId ? getCollection(state, ownProps.exampleCollectionId) : undefined,
        currentUser: getCurrentUser(state)
    };
};
const mapDispatchToProps = {
    onUndo: actions.undoChanges,
    addNotification: addNotificationToQueue
};
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector;

//# sourceMappingURL=CollectNotification.container.js.map